import { useState } from 'react';
import { PersonSearchItem } from 'type/person';
import { CustomerResultItem } from '../customerResult/CustomerResultItem';

interface MatchedPersonTypes {
  person: PersonSearchItem;
  onClick: () => void;
}

export const MatchedPerson = ({ person, onClick }: MatchedPersonTypes) => {
  const [isPersonClicked, setIsPersonClicked] = useState(false);

  const oneTimeClick = () => {
    if (!isPersonClicked) {
      onClick();
      setIsPersonClicked(true);
    }
  };

  return (
    <CustomerResultItem
      address={person.address}
      onClick={oneTimeClick}
      person={person}
      testId="select-person"
    />
  );
};
